export default __webpack_public_path__ + "static/media/Background_00065.ccdfdeab.png";